




















































































































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { EventBus } from "../event-bus";
import ConfirmationModal from "./ConfirmationModal.vue";
import axios from "axios";
import { Token } from "../utils/Token";
import { DeletedProfile } from "@/models/DeletedProfile";

@Component({
  components: {
    ConfirmationModal,
  },
})
export default class CreateDevice extends Vue {
  @Prop() readonly value!: boolean;
  private device = {
    firstName: "",
    lastName: "",
    pin: "",
    path: "",
    description: "",
    ipv4Address: "",
    netMask: "",
    gateway: "",
    altIpv4Address: "",
    altNetMask: "",
    altGateway: "",
    email:"",
    location:"",

  };
  // Deleted profile the form was prefilled from (Recreate), null on a plain create.
  private recreateFrom: DeletedProfile | null = null;
  private confirmationModalFlag = false;
  private errorModalFlag = false;
  private firstNameRules: any = [];
  private lastNameRules: any = [];
  private emailRules:any=[];
  private locationRules:any=[];
  private pinRules: any = [];
  private deviceRules: any = [];
  private descriptionRules: any = [];
  private ipv4Rules: any =[];
  private maskRules:any=[];
  private altIpv4Rules: any =[];
  private altMaskRules:any=[];
  private errorText = "";
  private errorTitle = "";
  private items: Array<any> = [
 ];
 

  get show() {
    return this.value;
  }

  set show(value: boolean) {
    EventBus.$emit("closeCreateDeviceModal", value);
  }

  created() {
    EventBus.$on("closeConfirmationModal", (value: boolean) => {
      this.confirmationModalFlag = value;
    });

    EventBus.$on("closeErrorModal", (value: boolean) => {
      this.errorModalFlag = value;
    });

    EventBus.$on("closeCreateDeviceModal", () => {
      this.device = {
        firstName: "",
        lastName: "",
        pin: "",
        path: "",
        description: "",
        ipv4Address: "",
        netMask: "",
        gateway: "",
        altIpv4Address: "",
        altNetMask: "",
        altGateway: "",
        email:"",
        location:"",
      };
      this.recreateFrom = null;
    });

    EventBus.$on("openRecreateDeviceModal", this.prefillFromDeleted);
  }

beforeDestroy () {
    EventBus.$off('closeErrorModal')
    EventBus.$off('closeConfirmationModal')
    EventBus.$off('closeCreateDeviceModal')
    EventBus.$off('openRecreateDeviceModal', this.prefillFromDeleted)
}

  // Recreate: prefill with the stored data of a deleted profile. PIN and USB
  // device are not stored and must be entered again, which also runs the
  // device license check as on a normal create.
  private prefillFromDeleted(profile: DeletedProfile) {
    this.recreateFrom = profile;
    this.device = {
      firstName: profile.firstName,
      lastName: profile.lastName,
      pin: "",
      path: "",
      description: profile.description,
      ipv4Address: profile.ipv4Address,
      netMask: this.toPrefixLength(profile.netMask),
      gateway: profile.gateway,
      altIpv4Address: profile.altIpv4Address,
      altNetMask: this.toPrefixLength(profile.altNetMask),
      altGateway: profile.altGateway,
      email: profile.email,
      location: profile.location,
    };
    // start without validation errors, like a fresh form
    this.firstNameRules = [];
    this.lastNameRules = [];
    this.emailRules = [];
    this.locationRules = [];
    this.pinRules = [];
    this.deviceRules = [];
    this.descriptionRules = [];
    this.ipv4Rules = [];
    this.maskRules = [];
    this.altIpv4Rules = [];
    this.altMaskRules = [];
  }

  // The form takes the mask as a prefix length (24); older profiles may have
  // it stored as "/24" or dotted ("255.255.255.0"). Anything else is kept as is.
  private toPrefixLength(mask: string): string {
    const value = (mask || "").trim().replace(/^\//, "");
    if (!/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(value)) {
      return value;
    }
    const octets = value.split(".").map(Number);
    if (octets.some((octet) => octet > 255)) {
      return value;
    }
    const bits = octets.map((octet) => octet.toString(2).padStart(8, "0")).join("");
    // only a contiguous mask (ones then zeros) has a prefix length
    return /01/.test(bits) ? value : String(bits.split("1").length - 1);
  }


  @Watch("device.firstName")
  firstNameChanged() {
    this.firstNameRules = [];
  }

  @Watch("device.lastName")
  lastNameChanged() {
    this.lastNameRules = [];
  }

  @Watch("device.email")
  emailChanged() {
    this.emailRules = [];
  }

  @Watch("device.location")
  locatinoChanged() {
    this.locationRules = [];
  }

  @Watch("device.extension")
  extensionChanged() {
    this.pinRules = [];
  }

  @Watch("device.description")
  descriptionChanged() {
    this.descriptionRules = [];
  }
  @Watch("device.path")
  pathChanged() {
    if (this.device.path!==undefined && this.device.path!=null && this.device.path.length>0 ){
      console.log("path:",this.device.path)
      this.checkDeviceLicense();              //The number of devices available on the License are completed. Bye a new license.
    }
  }


  private async fetchDevicePath() {
    const token = await Token.getTokenWithExpiry("token");
    ////EventBus.$emit("BeginLoader",null );   

    axios({
      method: "get",
      withCredentials: true,
      url: `${process.env.VUE_APP_BASE_URL}/devices/paths`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "application/json",
      },
    })
      .then((response) => {
        ////EventBus.$emit("FinishLoader",null );   

        if (response.data.code == 401) {
          EventBus.$emit("LogOutEventBus", false);
        } else {
          if (response.data.code == 200) {
            this.items = response.data.paths;
           
          }
        }
      })
      .catch((err) => {
        ////EventBus.$emit("FinishLoader",null );   

        console.log("error:", err);
      });
  }

  private submitHandler(): void {
    this.firstNameRules = [
      (v: any) => !!v || "First Name is required",
      (v: any) =>
        /^[a-zA-Z]+$/.test(v) || "First Name must contain only letters",
    ];

    this.lastNameRules = [
      (v: any) => !!v || "Last Name is required",
      (v: any) =>
        /^[a-zA-Z]+$/.test(v) || "Last Name must contain only letters",
    ];

    this.deviceRules = [(v: any) => !!v || "Device is required"];

    this.emailRules=[
      (v: any) => !!v || "Email is required",
      (v: any) =>
        /^\w+([.-_]\w+)*@\w+([.-_]\w+)*(\.[a-zA-Z]{2,5})+$/.test(v) || "invalid email",
    ];
    //accepted:
    //aaa9.9-k_o@y8.comp.edu.com    ang.sfyr@gmail.com    ang_sftr@yahoo.gr   tei@uniwa.edu.gr    teia.l@unima.gpr

    this.locationRules=[
      (v: any) => !!v || "Location is required",
      (v: any) =>
        /^[\w ]+(?:[,.-][\w ]+)*[,.-]?$/.test(v) || "Location must contain letters numbers -., ",
    ];
    this.pinRules = [
      (v: any) => !!v || "PIN is required",
      (v: any) => /^\d{4}$/.test(v) || "PIN must be 4 digits",
    ];

    this.ipv4Rules = [
      (v: any) => !!v || "Is required",
      (v: any) =>
        /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(v) || "Must be of the form xxx.xxx.xxx.xxx or x.x.x.x",
    ];
    
    this.maskRules = [
      (v: any) => !!v || "Is required",
      (v: any) =>
        /^\d{1,2}$/.test(v) || "Must be of the form /0-/32. Most common is /24.",
    ];

    // Alternate network config is optional: only validate the format when filled.
    this.altIpv4Rules = [
      (v: any) =>
        !v ||
        /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(v) ||
        "Must be of the form xxx.xxx.xxx.xxx or x.x.x.x",
    ];

    this.altMaskRules = [
      (v: any) =>
        !v || /^\d{1,2}$/.test(v) || "Must be of the form /0-/32. Most common is /24.",
    ];

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    setTimeout(function () {
      // In order for TypeScript to know which type is being used for form, we need to cast the value.
      const result = (
        self.$refs.form as Vue & {
          validate: () => boolean;
        }
      ).validate();
      console.log("result of validation:", result);
      console.log("device data to be submitted:", self.device);
      if (result) {
        // successful validation -> open confirmation modal
        self.confirmationModalFlag = true;
      } else {
        console.log("failed validation");
      }
    });
  }

  // close modal and clear input fields
  private cancel(): void {
    this.show = false;
    this.recreateFrom = null;
    this.device = {
      firstName: "",
      lastName: "",
      pin: "",
      path: "",
      description: "",
      ipv4Address: "",
      netMask: "",
      gateway: "",
      altIpv4Address: "",
      altNetMask: "",
      altGateway: "",
      email:"",
      location:"",

    };
  }

  private  async checkDeviceLicense(){
    let flag=true;
    const token = await Token.getTokenWithExpiry("token");

    await axios({
      method: "post",
      withCredentials: true,
      url: `${process.env.VUE_APP_BASE_URL}/license/validatePath`,
      data:{devicePath:this.device.path},
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "application/json",
      },
    })
      .then((response) => {

        if (response.data.code == 401) {
          EventBus.$emit("LogOutEventBus", false);
        } else {
          if (response.data.code == 200) {
            flag = response.data.flag;
           
          }
        }
      })
      .catch((err) => {

        console.log("error:", err);
      });
      //check serialization
    if (!flag){
    const snackbarData = {
        text:"Error: The number of devices available on the License are completed. Ask a new license.",
        color: "#2196f3",
        };
    EventBus.$emit("showSnackbar", snackbarData);

    }
  }
}

